// ============================================================
// SightRing - the reticle lock-on graphic (v8.242.1).
//
// A dashed steel ring with four crosshair ticks, solid gold when
// engaged - the grammar the targeting console taught, extracted so
// the target panel's body map can wear the same sights. GRAPHIC
// ONLY: the interactive <g role="button"> wrapper (testids, aria,
// click/keyboard handlers, tooltips) stays with each caller, because
// the gestures and locators differ by design between surfaces.
//
// The ticks span 0.55r..r, which is what leaves the CENTRE clear - a
// plate's location anchor shows through it like a scope readout.
// ============================================================
import styles from '../styles/SightRing.module.css';
import clsx from '../utils/clsx';

interface Props {
  cx: number;
  cy: number;
  r: number;
  /** Stroke scale factor in the host's frame: the ring is 22 x this, its strokes scaled alike. */
  sf: number;
  engaged: boolean;
}

export default function SightRing({ cx, cy, r, sf, engaged }: Props) {
  return (
    <>
      <circle
        cx={cx}
        cy={cy}
        r={r}
        className={clsx(styles.node, engaged && styles.nodeEngaged)}
        pointerEvents="all"
        strokeWidth={1.5 * sf}
        strokeDasharray={engaged ? undefined : `${4 * sf} ${3 * sf}`}
      />
      {/* Crosshair ticks */}
      <line x1={cx - r} y1={cy} x2={cx - r * 0.55} y2={cy} className={styles.tick} strokeWidth={1.5 * sf} />
      <line x1={cx + r * 0.55} y1={cy} x2={cx + r} y2={cy} className={styles.tick} strokeWidth={1.5 * sf} />
      <line x1={cx} y1={cy - r} x2={cx} y2={cy - r * 0.55} className={styles.tick} strokeWidth={1.5 * sf} />
      <line x1={cx} y1={cy + r * 0.55} x2={cx} y2={cy + r} className={styles.tick} strokeWidth={1.5 * sf} />
    </>
  );
}
